import React, { useState, useContext, useEffect } from 'react'
import axios from 'axios'

export default function App() {
  const [drzavi, setDrzavi] = useState([]);
  const [drzaviPrikaz, setDrzaviPrikaz] = useState([]);
  const [posledno, setPosledno] = useState('/');
  const [baraj, setBaraj] = useState('');
  useEffect(() => {
    const zemiDrzavi = async () => {
      let drzavi = await axios.get(`https://applepaymk-cron.onrender.com`);
      console.log(drzavi.data);

      drzavi = drzavi.data;
      if (!!drzavi.drzavi) {
        setDrzavi(drzavi.drzavi);
        setDrzaviPrikaz(drzavi.drzavi);
      }
      setPosledno(drzavi.posledno);
    }

    zemiDrzavi();
  }, []);

  useEffect(() => {
    let drzaviP = drzavi.filter(d => d.ime.toLowerCase().includes(baraj.toLowerCase()));
    console.log('123');
    setDrzaviPrikaz(drzaviP);
  }, [baraj])


  return (
    <div className="container mx-auto mt-20">
      <p className='text-xs'>Последно обновено: {posledno.split("GMT")[0]}</p>
      <iframe className='w-full mt-2' height={150} src="https://applepaymk-iframe.netlify.app" frameborder="0"></iframe>

      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="py-3 pl-2">
            <div className="relative w-full">
              {/* <label htmlFor="hs-table-search" className="">
                Барај...
              </label> */}
              <input
                onChange={(e) => setBaraj(e.target.value)}
                type="text"
                name="hs-table-search"
                id="hs-table-search"
                className="block w-full p-3 pl-10 text-sm border-gray-200 rounded-md focus:border-blue-500 focus:ring-blue-500 "
                placeholder="Барај..."
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <svg
                  className="h-3.5 w-3.5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </div>
            </div>
          </div>

          <div className="p-1.5 w-full inline-block align-middle">
            <div className="overflow-hidden border rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>

                    <th
                      scope="col"
                      className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase "
                    >
                      Листа на држави
                    </th>

                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {
                    drzaviPrikaz.map(drzava => {
                      return (
                        <tr>
                          <td className="px-6 py-4 text-sm flex items-center text-gray-800 whitespace-nowrap">
                            <img width="32" height="32" src={`./flags/${drzava.slika}.svg`} />
                            <p className='ml-4'>{drzava.ime}</p>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}